module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/169.3f3cf0ef.png";